import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the extras box; each part uses its own slice of it */
import styles from './ServiceExtras.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ServiceExtrasSwitchProps {
  label: string;
  isOn: boolean;
  /** The save runs: the spinner knob (design spotify-canvas b2 "Saving"). */
  isSaving: boolean;
  /** Off and dimmed (design b2 "demo"). */
  isDimmed: boolean;
  onToggle: () => void;
  testId?: string;
}

/** The switch of an auto upload (design spotify-canvas b2, d3): a button with the role "switch". */
const ServiceExtrasSwitchComponent: React.FC<ServiceExtrasSwitchProps> = ({
  label,
  isOn,
  isSaving,
  isDimmed,
  onToggle,
  testId,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={isOn}
    aria-label={label}
    aria-busy={isSaving}
    disabled={isDimmed || isSaving}
    className={clsx(
      styles.switch,
      isOn && styles.switchOn,
      isSaving && styles.switchBusy,
      isDimmed && styles.switchDimmed
    )}
    onClick={onToggle}
    data-testid={testId}
  />
);

export const ServiceExtrasSwitch = TypedMemo(ServiceExtrasSwitchComponent);
